import { useEffect } from 'react';
import { getGlobalConfig } from '../global/ConfigProvider';

export function useTracking(
  eventName?: string,
  details?: Record<string, unknown>
) {
  const { trackEvent } = getGlobalConfig();
  useEffect(() => {
    if (eventName) {
      trackEvent(eventName, details ?? {});
    }
  }, [eventName, details, trackEvent]);
  return trackEvent;
}
